import axios from "axios"
import { categoriaPadresAdapter } from "./Categoria.adapter"
import { CategoriaReadingDtoProps } from "./DTOs/CategoriaReadingDto"

export async function getCategoriaPadresByNif(
  nif: string
): Promise<CategoriaReadingDtoProps[]> {
  const { data } = await axios.get(`/Categoria/padres-by-nif/${nif}`)
  return data.map((categoria: CategoriaReadingDtoProps) =>
    categoriaPadresAdapter(categoria)
  )
}

export async function getCategoriaAllPadres(): Promise<
  CategoriaReadingDtoProps[]
> {
  const { data } = await axios.get("/Categoria/padres")
  return data.map((categoria: CategoriaReadingDtoProps) =>
    categoriaPadresAdapter(categoria)
  )
}

export async function getCategoriasItems(): Promise<
  CategoriaReadingDtoProps[]
> {
  const { data } = await axios.get("/Categoria/items")
  return data.map((categoria: CategoriaReadingDtoProps) =>
    categoriaPadresAdapter(categoria)
  )
}
